function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.640,0.101 C4.640,0.101 0.086,5.743 0.086,5.743 C0.085,5.745 0.085,5.745 0.084,5.747 C0.057,5.780 0.036,5.818 0.021,5.862 C0.007,5.905 -0.001,5.951 -0.001,5.998 C-0.001,5.998 -0.001,5.999 -0.001,6.000 C-0.001,6.047 0.007,6.094 0.021,6.139 C0.037,6.183 0.058,6.223 0.086,6.256 C0.086,6.256 4.640,11.898 4.640,11.898 C4.757,12.040 4.945,12.040 5.060,11.898 C5.119,11.828 5.148,11.735 5.148,11.642 C5.148,11.550 5.119,11.457 5.060,11.386 C5.060,11.386 1.013,6.362 1.013,6.362 C1.013,6.362 13.690,6.362 13.690,6.362 C13.854,6.362 13.987,6.200 13.987,6.000 C13.987,5.800 13.854,5.638 13.690,5.638 C13.690,5.638 1.013,5.638 1.013,5.638 C1.013,5.638 5.060,0.613 5.060,0.613 C5.119,0.542 5.148,0.450 5.148,0.357 C5.148,0.264 5.119,0.172 5.060,0.101 C4.945,-0.040 4.757,-0.040 4.640,0.101 ",
  fillRule: "evenodd"
});

function SvgIconBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon-back",
    viewBox: "0 0 14 12",
    fill: "#000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon-back.ad412859.svg";
export { ForwardRef as ReactComponent };